import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import myDetector from "./myDetector";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const languageDetector = new LanguageDetector();
languageDetector.addDetector(myDetector);

const options = {
  // order and from where user language should be detected
  order: ["myDetector"],

  // cache user language on
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"] // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  //cookieMinutes: 10,
  //cookieDomain: "myDomain",

  // optional htmlTag with lang attribute, the default is:
  //htmlTag: document.documentElement,

  // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
  //cookieOptions: { path: "/", sameSite: "strict" },
};

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    //detection
    detection: options,
    // Configuration pour la compatibilité avec Chrome 49 (pas de support Intl.PluralRules)
    compatibilityJSON: 'v3',
    resources: {
      en: {
        translations: {
          version: "Version",
          home: "Home",
          close: "Close",
          powered: "Powered by Xeester",
          fullscreen: "Full screen",
          exitFullscreen: "Exit Full screen",
          options: "Options",
          hand: "Hand",
          buyin: "Buy-in",
          level: "Level",
          hero: "Hero",
          player: "Player",
          background: "Background",
          table: "Table",
          shortcuts: "Shortcuts",
          not_allowed: "This replay is private",
          not_exists: "Wrong replay id",
          gotoXeester: "Go to Xeester",
          disclaimer: "Using Xeester complies with the Terms and Conditions of supported websites. Copyright © 2011 - [DATE] Xeester, all rights reserved.",
          noResults: "No results",
          hudDisclaimer  : "Mouse over a player to see their HUD",
          error: {
            title: "Oops, something went wrong",
            message:
              "We apologize for the inconvenience, please try again later",
            reload: "Reload",
            wrong_id: "Wrong replay id"
          },
          actionbar: {
            winamaxNav: "Winamax navigation",
            firstHand: "First hand",
            tenLessHand: "Ten hands before",
            previousHand: "Previous hand",
            previousAction: "Previous action",
            nextAction: "Next action",
            nextHand: "Next hand",
            tenMoreHand: "Ten hands later",
            lastHand: "Last hand",
            play: "Play",
            replay: "Replay",
            stop: "Stop",
            spacebar: "Space bar",
            speed: "Speed",
            timeline: "Timeline",
            sounds_mute: "Mute",
            sounds_unmute: "Unmute"
          },
          events: {
            NONE: "",
            FOLD: "Folds",
            CHECK: "Checks",
            CALL: "Calls",
            BET: "Bets",
            RAISE: "Raises",
            UNCALLED_BET: "Uncalled bet",
            POSTS_SB: "Posts small blind",
            POSTS_BB: "Posts big blind",
            POSTS_DEAD_BB: "Posts a blind",
            POSTS_ANTE: "Posts ante",
            COLLECT: "Collects",
            WON_HAND: "Won the hand",
            FINISH: "Finished the tournament",
            WIN_BOUNTY: "Wins a bounty",
            REBUY: "Rebuy",
            DOUBLE_REBUY: "Double Rebuy",
            SAID: "Says",
            SHOW: "Shows",
            MUCK: "Mucks",
            REALLYMUCK: "Mucks",
            AT_SHOWDOWN: "Is at showdown",
            DECONNECT: "Is deconnected",
            RECONNECT: "Is reconnecting",
            TANK: "Tanks",
            SITOUT: "Sits out",
            SITIN: "Sits down"
          },
          sessionTypes: {
            1: "Tournament",
            2: "Cashgame"
          },
          replayApp: {
            // v2-1379 : le bandeau du jeton Space KO
            spaceKoLevel: "Level",
            spaceKoAvg: "Avg",
            view: "view",
            views: "views",
            subscribe: "subscribe",
            unsubscribe: "unsubscribe",
            subscriber: "subscriber",
            subscribers: "subscribers",
            related: "Last replays",
            played: "Played",
            edit: "Edit hand",
            cancel: "Cancel",
            user_replay: "replay",
            user_replays: "replays",
            winner: "Winner",
            comment: "comment",
            comments: "comments",
            post_comment: "Comment",
            comment_placeholder: "Add a public comment...",
            visibility: {
              private: "Private",
              public: "Public",
              switch: "Switch to"
            },
            delete: "Delete",
            deleteReplay: "Delete replay",
            deleteReplayMessage: "This action is irreversible.",
            deleteReplayMessage2: "Do you want to delete this replay?",
            deleted: "Replay deleted",
            deletedError: "Replay could not be deleted",
            share: {
              facebook: "Share on Facebook",
              twitter: "Share on Twitter",
              embed: "Integrate",
              link: "Copy url",
              copied: "Link copied to clipboard",
              copyCode: "Copy code",
              codeCopied: "Code copied to clipboard"
            },
            user: {
              login: "Login",
              password: "Password",
              email: "email",
              signUp: "Sign Up",
              disconnect: "Disconnect",
              username: "Username",
              login_username: "Login",
              error: "Incorrect credentials",
              forgot: "Forgot your password?",
              alreadyMember: "Alreay a member?",
              notMemberYet: "No account yet?",
              discover: "Discover Xeester",
              showReplays: "My replays",
              remember: "Remember me"
            },
            votes: {
              title: "Votes",
              icon: "VO",
              singular: "vote",
              plural: "votes",
              0: "No opinion",
              1: "Great play",
              2: "Nice bluff",
              3: "Oh my god!",
              4: "Bad beat"
            }
          },
          navigation: {
            home: "Home",
            history: "History",
            myReplays: "My chanel",
            settings: "Settings",
            rankings: {
              title: "Rankings",
              viewed: "Most viewed",
              last: "Last replays",
              commented: "Most commented",
              voted: "Most voted",
              private: "Private",
              public: "Public"
            },
            subscriptions: {
              title: "Subscriptions"
            }
          },
          chanelApp: {
            lastReplays: "Last replays",
            mostViewed: "Most viewed",
            home: "Home",
            replays: "Replays",
            search: "Search",
            filters: {
              all: "All",
              allPrivate: "Make all private",
              allPublic: "Make all public",
              allPrivateConfirm: "Make {{count}} replay private?",
              allPrivateConfirm_plural: "Make {{count}} replays private?",
              allPublicConfirm: "Make {{count}} replay public?",
              allPublicConfirm_plural: "Make {{count}} replays public?",
              allPublicWarning: "Replays you made private one by one will become public again.",
              allError: "The change could not be made.",
              confirm: "Confirm",
              cancel: "Cancel",
              select: "Select"
            },
            selection: {
              count: "Selected: {{count}}",
              all: "Select all",
              none: "Deselect all",
              delete: "Delete",
              cancel: "Cancel",
              deleteTitle: "Delete the selected replays",
              deleteConfirm: "Delete {{count}} replay? Its comments, votes and views go with it.",
              deleteConfirm_plural: "Delete {{count}} replays? Their comments, votes and views go with them.",
              deleted: "{{count}} replay deleted",
              deleted_plural: "{{count}} replays deleted",
              deleteError: "The replays could not be deleted.",
              deletePartial: "{{count}} replay deleted, the others could not be.",
              deletePartial_plural: "{{count}} replays deleted, the others could not be.",
              public: "Make public",
              private: "Make private",
              publicTitle: "Make the selected replays public",
              privateTitle: "Make the selected replays private",
              madePublic: "{{count}} replay made public",
              madePublic_plural: "{{count}} replays made public",
              madePrivate: "{{count}} replay made private",
              madePrivate_plural: "{{count}} replays made private",
              visibilityPartial: "{{count}} replay changed, the others could not be.",
              visibilityPartial_plural: "{{count}} replays changed, the others could not be."
            },
            edit: "Customize my chanel"
          },
          homeApp: {
            featured: "Most viewed"
          },
          ads: {
            sponsored: "Sponsored content"
          },
          landing: {
            h1: "Go all in",
            h2: "Share your replays!",
            description:
              "Posting your best poker hands has never been easier than with Opencards. In one click, publish, share, then ask your questions to <a href='/' target='_blank'>Xeester</a> community of over 60,000 players!<br>Become an emeritus member and give your advice and opinion on the best (but also the worst) hands you see ...<br><br>It's time to go to showdown!",
            publishLive: "Publish live from your HUD",
            publishLiveDescription:
              "You were in the middle of a good run, hyper concentrated, and now villain has just reduced your stack by half by going fishing with 7-2 offsuit in his hands ... <br> Share your anger, and publish in one click from your HUD this last hand, and collect the opinions of the community! <br> <br> But beware, everyone may not share your point of view ...",
            share: "Share your former hands",
            shareDescription:
              "You just left the table, poker is over for tonight! <br> But you can't help but think back to those few key hands that got your hearbeat rising ... <br> Did you make the right decisions? Did you analyze your opponents well? <br> And then there is this famous last hand, which finally made you win this tournament which lasted almost 6 hours ... <br> <br> Share it with others , reopen your hand on Xeester and post it!",
            featuredHand: "Will you have the hand of the month?",
            openHand: "Watch that hand"
          },
          settings: {
            infos: "Information",
            display: "Display",
            update: "Update",
            description: "Description of your chanel",
            description_placeholder:
              "Write a short description about you and your poker game",
            notifications: "Email notifications",
            notify_subscriptions: "When a user subscribes to my chanel",
            notify_comments: "When a new comment is posted",
            notify_replays: "When a new video is posted",
            update_error: "An error occured",
            description_updated: "Description updated",
            notifications_updated: "Notifications updated",
            banner: "Banner image",
            banner_text:
              "For the best results on all devices, use an image that’s at least 2048 x 335 pixels and 2MB or less.",
            banner_size_error: "Use an image that’s at least 2048 x 335 pixels",
            banner_weight_error: "Use an image that’s 2 Mo or less",
            avatar: "Avatar",
            avatar_text:
              "Use a square picture that’s at least 128 x 128 pixels and 500 ko or less.",
            avatar_size_error:
              "Use a square image that’s at least 128 x 128 pixels",
            avatar_weight_error: "Use an image that’s 500 ko or less",
            upload: "Upload",
            change: "Change",
            gallery: "Gallery"
          },
          poktools: {
            back: "Back",
            pending: "Your evaluation will end in [NB] days",
            unauthorized:
              "Your license is no longer valid, upgrade to TITAN to use the tools!",
            positions: {
              LJ: "Lo Jack",
              HJ: "Hi Jack",
              CO: "Cut Off",
              BU: "Button",
              SB: "Small Blind",
              BB: "Big Blind"
            },
            trainer: {
              title: "TRAINER",
              description:
                "TRAINER is a tool that allows you to train in preflop situations. This tool is an effective way to easily correct leaks. With three difficulty levels, it adapts to your level of play whether you are a beginner or a more experienced player.",
              start: "Start training",
              options: "Options",
              right_answer: "The EV in this spot is [EV] BB!",
              wrong_answer: "ATTENTION: EV in this spot is [EV] BB!",
              next: "Next >",
              speed: {
                0: "No timer",
                2: "2 seconds",
                5: "5 seconds",
                10: "10 seconds"
              },
              level: {
                name: "Difficulty",
                1: "Easy",
                2: "Average",
                3: "Hard"
              },
              game: {
                name: "Game type"
              },
              situation: {
                name: "Situation",
                or: "or"
              },
              hero: "hero",
              vilain: "vilain"
            },
            fastpok: {
              title: "FASTPOK",
              description:
                "FastPok is both a preflop solver and decision helper software. So its hybrid design allows it to benefit from the speed of decision helper software and the precision of preflop solvers.",
              start: "Start",
              situation: {
                title: "Situation"
              },
              players: {
                title: "Number of players",
                short: "players"
              },
              vilain: {
                title: "Position(s) of the villain(s)"
              },
              position: {
                title: "Position"
              },
              stack: {
                title: "Effective stack (in , min = 2BB)"
              },
              ante: {
                title: "Ante (in% of BB)"
              },
              launch: "Start the analysis",
              analysis: {
                title: "Analyse",
                tip: "Pass the mouse over one hand to see the detail",
                nodata: "Select criteria"
              },
              open_push:
                "No one opened before me, can I move all-in profitably?",
              call_push: "I am facing a push, what should I do?"
            },
            rp: {
              title: "Risk Premium",
              description:
                "Risk Premium allows you to know the equity a player needs when he goes all-in against another in a situation where there is an impact related to the ICM. Knowing the Risk Premium of a situation all-in allows to avoid making ICM errors, so it is particularly suitable for poker tournaments.",
              start: "Start",
              stacks: "Stacks",
              payouts: "Rewards",
              add: "Add",
              calculate: "Calculate",
              reset: "Reset",
              prorata: "Pro rata",
              chips: "Tokens",
              warning:
                "Specify 'a stack VS a stack' to speed up the calculation"
            },
            error: "An error has occurred"
          }
        }
      },
      fr: {
        translations: {
          version: "Version",
          home: "Page d'accueil",
          close: "Fermer",
          powered: "Propulsé par Xeester",
          fullscreen: "Plein écran",
          exitFullscreen: "Quitter le mode plein écran",
          options: "Options",
          hand: "Main",
          buyin: "Buy-in",
          level: "Niveau",
          hero: "Heros",
          player: "Joueur",
          background: "Fond",
          table: "Table",
          shortcuts: "Raccourcis",
          not_allowed: "Ce replay est privé",
          not_exists: "Ce replay n'existe pas",
          gotoXeester: "Aller sur Xeester",
          disclaimer: "Utiliser Xeester est conforme aux Termes et Conditions des sites web pris en charge. Droits d'auteur © 2011 - [DATE] Xeester, tous droits réservés.",
          noResults: "Aucun résultat",
          hudDisclaimer  : "Passe la souris sur un joueur pour voir son HUD",
          error: {
            title: "Oops, un problème est survenu",
            message:
              "Nous vous prions de nous excuser pour la gêne occasionnée, veuillez réessayer plus tard",
            reload: "Recharger",
            wrong_id: "Mauvais id de replay"
          },
          actionbar: {
            winamaxNav: "Navigation Winamax",
            firstHand: "Première main",
            tenLessHand: "10 mains avant",
            previousHand: "Main précédente",
            previousAction: "Action précédente",
            nextAction: "Action suivante",
            nextHand: "Main suivante",
            tenMoreHand: "10 mains après",
            lastHand: "Dernière main",
            play: "Jouer",
            replay: "Rejouer",
            stop: "Arrêter",
            spacebar: "Barre d'espace",
            speed: "Vitesse",
            timeline: "Chronologie",
            sounds_mute: "Désactiver le son",
            sounds_unmute: "Réactiver le son"
          },
          pot: "Pot",
          amountToCall : "Montant à investir",
          events: {
            NONE: "",
            FOLD: "Se couche",
            CHECK: "Check",
            CALL: "Call",
            BET: "Bet",
            RAISE: "Raise",
            UNCALLED_BET: "Récupère sa mise",
            POSTS_SB: "Pose small blind",
            POSTS_BB: "Pose big blind",
            POSTS_DEAD_BB: "Pose une blind",
            POSTS_ANTE: "Pose un ante",
            COLLECT: "Récupère",
            WON_HAND: "A gagné la main",
            FINISH: "A fini le tournoi",
            WIN_BOUNTY: "Gagne un bounty",
            REBUY: "Rebuy",
            DOUBLE_REBUY: "Double Rebuy",
            SAID: "Dit",
            SHOW: "Montre",
            MUCK: "Cache",
            REALLYMUCK: "Cache",
            AT_SHOWDOWN: "Est au showdown",
            DECONNECT: "Est déconnecté",
            RECONNECT: "Se reconnecte",
            TANK: "Tank",
            SITOUT: "Sits out",
            SITIN: "Sits down"
          },
          sessionTypes: {
            1: "Tournoi",
            2: "Cashgame"
          },
          money:{
            1 : "Réel",
            2 : "Points",
            3 : "Fun"
          },
          currency:{
            0 : "FPP",
            1 : "€",
            3 : "£",
            4 : "¥"
          },
          replayApp: {
            // v2-1379 : le bandeau du jeton Space KO
            spaceKoLevel: "Palier",
            spaceKoAvg: "Moy",
            view: "vue",
            views: "vues",
            subscribe: "S'abonner",
            unsubscribe: "Se désabonner",
            subscriber: "abonné",
            subscribers: "abonnés",
            related: "Derniers replays",
            played: "Joué le",
            edit: "Editer la main",
            cancel: "Annuler",
            user_replay: "replay",
            user_replays: "replays",
            winner: "Gagnant",
            comment: "commentaire",
            comments: "commentaires",
            post_comment: "Commenter",
            comment_placeholder: "Ajouter un commentaire public...",
            visibility: {
              private: "Privé",
              public: "Public",
              switch: "Mettre en"
            },
            delete: "Supprimer",
            deleteReplay: "Supprimer le replay",
            deleteReplayMessage: "Cette action est irréversible.",
            deleteReplayMessage2: "Voulez-vous supprimer ce replay ?",
            deleted: "Replay supprimé",
            deletedError: "Le replay n'a pas pu être supprimé",
            share: {
              facebook: "Partager sur Facebook",
              twitter: "Partager sur Twitter",
              embed: "Intégrer",
              link: "Copier l'url",
              copied: "Lien copié dans le presse-papiers",
              copyCode: "Copier le code",
              codeCopied: "Code copié dans le presse-papiers"
            },
            user: {
              login: "Se connecter",
              password: "Mot de passe",
              email: "email",
              signUp: "S'inscrire",
              disconnect: "Se déconnecter",
              username: "Identifiant",
              login_username: "Identifiant",
              error: "Identifiants incorrects",
              error_code: {
                0: "Identifiant ou mot de passe incorrect",
                8: "Vous êtes déjà connecté à un autre ordinateur, veuillez vous déconnecter d'abord.",
                5: "Un autre compte est déjà enregistré pour cet ordinateur ([OTHER])",
                2: "Votre période d'évaluation est terminée. Afin de pouvoir utiliser Xeester en argent réel, mrci de vous abonner."
              },
              forgot: "Mot de passe oublié ?",
              alreadyMember: "Déjà membre ?",
              notMemberYet: "Pas encore inscrit ?",
              discover: "Découvre Xeester",
              showReplays: "Voir mes replays",
              remember: "Mémoriser mes identifiants"
            },
            votes: {
              title: "Votes",
              icon: "VO",
              singular: "vote",
              plural: "votes",
              0: "Sans avis",
              1: "Bien joué",
              2: "Joli bluff",
              3: "Oh mon dieu !",
              4: "Bad beat"
            }
          },
          navigation: {
            home: "Accueil",
            history: "Historique",
            myReplays: "Ma chaîne",
            settings: "Préférences",
            rankings: {
              title: "Rankings",
              viewed: "Plus vus",
              last: "Derniers replays",
              commented: "Plus commentés",
              voted: "Plus votés",
              private: "Privés",
              public: "Publics"
            },
            subscriptions: {
              title: "Abonnements"
            }
          },
          chanelApp: {
            lastReplays: "Derniers replays",
            mostViewed: "Les plus vus",
            home: "Accueil",
            replays: "Replays",
            search: "Rechercher",
            filters: {
              all: "Tous",
              allPrivate: "Tout passer en privé",
              allPublic: "Tout passer en public",
              allPrivateConfirm: "Passer {{count}} replay en privé ?",
              allPrivateConfirm_plural: "Passer {{count}} replays en privé ?",
              allPublicConfirm: "Passer {{count}} replay en public ?",
              allPublicConfirm_plural: "Passer {{count}} replays en public ?",
              allPublicWarning: "Les replays que tu as passés en privé un par un redeviendront publics.",
              allError: "Le changement n'a pas pu être fait.",
              confirm: "Confirmer",
              cancel: "Annuler",
              select: "Sélectionner"
            },
            selection: {
              count: "Sélection : {{count}}",
              all: "Tout sélectionner",
              none: "Tout désélectionner",
              delete: "Supprimer",
              cancel: "Annuler",
              deleteTitle: "Supprimer les replays sélectionnés",
              deleteConfirm: "Supprimer {{count}} replay ? Ses commentaires, votes et vues partent avec lui.",
              deleteConfirm_plural: "Supprimer {{count}} replays ? Leurs commentaires, votes et vues partent avec eux.",
              deleted: "{{count}} replay supprimé",
              deleted_plural: "{{count}} replays supprimés",
              deleteError: "Les replays n'ont pas pu être supprimés.",
              deletePartial: "{{count}} replay supprimé, les autres n'ont pas pu l'être.",
              deletePartial_plural: "{{count}} replays supprimés, les autres n'ont pas pu l'être.",
              public: "Passer en public",
              private: "Passer en privé",
              publicTitle: "Passer les replays sélectionnés en public",
              privateTitle: "Passer les replays sélectionnés en privé",
              madePublic: "{{count}} replay passé en public",
              madePublic_plural: "{{count}} replays passés en public",
              madePrivate: "{{count}} replay passé en privé",
              madePrivate_plural: "{{count}} replays passés en privé",
              visibilityPartial: "{{count}} replay changé, les autres n'ont pas pu l'être.",
              visibilityPartial_plural: "{{count}} replays changés, les autres n'ont pas pu l'être."
            },
            edit: "Editer"
          },
          homeApp: {
            featured: "Les plus vus"
          },
          ads: {
            sponsored: "Contenu sponsorisé"
          },
          landing: {
            h1: "Fais toi mousser",
            h2: "Partage tes replays !",
            description:
              "Publier tes meilleurs coups de poker n’aura jamais été aussi facile qu’avec Opencards. En un clic publie, partage, puis pose tes questions à notre communauté <a href='/' target='_blank'>Xeester</a> de plus de 60,000 joueurs !<br>Deviens un membre émérite et donne tes conseils et ton avis sur les meilleures (mais aussi les pires) mains que tu vois…<br><br>Il est temps que tu abattes tes cartes !",
            publishLive: "Publie en live depuis ton HUD",
            publishLiveDescription:
              "Tu étais en plein good run, hyper concentré, et voila que vilain vient de réduire ton stack de moitié en partant à la pêche avec une poubelle entre les mains...<br>Fais part de ta colère, et publie en un clic depuis ton HUD cette dernière main, et récolte les avis de la communauté !<br><br>Mais attention, tout le monde ne partagera peut-être pas ton point de vue...",
            share: "Partage tes mains déjà jouées",
            shareDescription:
              "Tu viens de quitter la table, le poker c’est fini pour ce soir!<br>Mais tu ne peux pas t’empêcher de repenser à ces quelques mains clés qui t’ont fait battre la chamade...<br>As-tu fais ce qu’il fallait ? As-tu bien analysé tes adversaires ?<br>Et puis il y a cette fameuse dernière main, qui t’a finalement fait gagner ce tournoi qui a duré presque 6h...<br><br>Fais-en profiter les autres, rouvre ta main sur Xeester et publie la !",
            featuredHand: "Seras-tu le joueur de la main du mois ?",
            openHand: "Voir la main"
          },
          settings: {
            infos: "Information",
            display: "Affichage",
            update: "Mettre à jour",
            description: "Description de votre chaîne",
            description_placeholder:
              "Donnez une courte description à propos de vous et votre jeu de poker",
            notifications: "Notifications par email",
            notify_subscriptions: "Lorsqu'un joueur s'abonne à ma chaîne",
            notify_comments: "Lorsqu'un nouveau commentaire est posté",
            notify_replays: "Lorsqu'une nouvelle vidéo est postée",
            update_error: "Une erreur est survenue",
            description_updated: "Description mise à jour",
            notifications_updated: "Motifications mises à jour",
            banner: "Bannière",
            banner_text:
              "Pour obtenir les meilleurs résultats sur tous les appareils, utilisez une image d'au moins 2048 x 335 pixels et de 2 Mo ou moins.",
            banner_size_error:
              "Utilisez une image d'au moins 2048 x 335 pixels",
            banner_weight_error: "Utilisez une image de 2 Mo ou moins",
            avatar: "Avatar",
            avatar_text:
              "Utilisez une image carrée d'au moins 128 x 128 pixels et de 500 ko ou moins.",
            avatar_size_error:
              "Utilisez une image carrée d'au moins 128 x 128 pixels",
            avatar_weight_error: "Utilisez une image carrée de 500 ko ou moins",
            upload: "Télécharger",
            change: "Changer",
            gallery: "Gallerie"
          },
          poktools: {
            back: "Retour",
            pending: "Votre évalution terminera dans [NB] jours",
            unauthorized:
              "Votre licence n'est plus valide, upgradez en TITAN pour utiliser les outils !",
            positions: {
              LJ: "Lo Jack",
              HJ: "Hi Jack",
              CO: "Cut Off",
              BU: "Bouton",
              SB: "Small Blind",
              BB: "Big Blind"
            },
            trainer: {
              title: "TRAINER",
              description:
                "TRAINER est un outil qui permet de s’entraîner dans des situations preflop. Cet outil est un moyen efficace de corriger facilement des leaks. Disposant de trois niveaux de difficultés, il s’adapte à votre niveau de jeu que vous soyez un débutant ou un joueur plus expérimenté.",
              start: "Démarrer l'entraînement",
              options: "Options",
              right_answer: "BRAVO ! L'EV dans ce spot est de [EV] BB !",
              wrong_answer: "ATTENTION : l'EV dans ce spot est de [EV] BB !",
              next: "Suivant >",
              speed: {
                0: "Pas de timer",
                2: "2 secondes",
                5: "5 secondes",
                10: "10 secondes"
              },
              level: {
                name: "Difficulté",
                1: "Facile",
                2: "Moyen",
                3: "Difficile"
              },
              game: {
                name: "Type de jeu"
              },
              situation: {
                name: "Situation",
                or: "ou"
              },
              hero: "héros",
              vilain: "vilain"
            },
            fastpok: {
              title: "FASTPOK",
              description:
                "FastPok est à la fois un solveur preflop et un logiciel d'aide à la prise de décision. Ainsi sa conception hybride lui permet de bénéficier de la rapidité des logiciels d'aide à la prise de décision et de la précision des solveurs preflop.",
              start: "Démarrer",
              situation: {
                title: "Situation"
              },
              players: {
                title: "Nombre de joueurs",
                short: "joueurs"
              },
              vilain: {
                title: "Position(s) du (des) vilain(s)"
              },
              position: {
                title: "Position"
              },
              stack: {
                title: "Stack effectif (en BB, min = 2BB)"
              },
              ante: {
                title: "Ante (en % de BB)"
              },
              launch: "Lancer l'analyse",
              analysis: {
                title: "Analyse",
                tip: "Passez la souris sur une main pour voir le détail",
                nodata: "Sélectionnez les critères"
              },
              open_push:
                "Personne n'a ouvert jusqu'à moi, puis-je faire tapis profitablement ?",
              call_push: "Je fais face à un push, que dois-je faire ?"
            },
            rp: {
              title: "Risk Premium",
              description:
                "Le Risk Premium permet de connaître l'équité dont a besoin un joueur lorsqu'il part à tapis contre un autre dans une situation où il y a un impact lié à l'ICM. Connaître le Risk Premium d'une situation à tapis permet d'éviter de faire des erreurs ICM, c'est donc un outil particulièrement adapté aux tournois de poker.",
              start: "Démarrer",
              stacks: "Stacks",
              payouts: "Récompenses",
              add: "Ajouter",
              calculate: "Calculer",
              reset: "Réinitialiser",
              prorata: "Prorata",
              chips: "Jetons",
              warning:
                "Précisez 'un stack VS un stack' pour accélerer le calcul"
            },
            error: "Une erreur est survenue"
          },
          app: {
            cancel: "Annuler",
            delete: "Supprimer",
            menus: {
              start: {
                title: "Démarrer",
                bookmarks: "Favoris",
                account: "Mon compte",
                finished_sessions: "Enlever les session terminées de LIVE",
                repair: "Réparer la base de données",
                backups: "Gestion des sauvegardes",
                exit: "Quitter"
              },
              edition: {
                title: "Edition",
                bookmark: "Ajouer aux favoris",
                select_all: "Tout sélectionner",
                search: "Rechercher",
                reload: "Rafraichir"
              },
              hud: {
                title: "HUD et profils"
              },
              import: {
                title: "Import"
              },
              options: {
                title: "Options"
              }
            },
            statistics: {
              actionTypes: {
                AGRESSION: "Agression",
                SELECTION: "Sélection",
                PASSIVITY: "Passivité",
                RESISTANCE: "Résistance"
              }
            },
            backup: {
              title: "Gestion des backups",
              computer: "Ordinateur",
              date: "Date",
              size: "Taille",
              restore: "Restaurer",
              create: "Nouveau",
              cancel: "Annuler",
              cancel_backup_message: "Voulez-vous vraiment annuler le backup ?",
              cancel_backup: "Annuler le backup",
              cancel_restore: "Annuler la restauration",
              cancel_restore_message:
                "Voulez-vous vraiment annuler la restauration ?",
              continue_backup: "Continuer",
              confirm_restore_message:
                "Lancer la restauration de cette sauvegarde ?",
              shutting_down: "L'application va maintenant se fermer",
              event: {
                STOPPING_HUD: "Arrêt du HUD",
                COUNTING_FILES: "Evaluation des fichiers",
                CREATING_BACKUP_FOLDER: "Création du dossier",
                SENDING_PROCESSED: "Envoi des historiques",
                ZIPPING_PROCESSED_CHUNK: "Envoi des historiques",
                SENDING_PROCESSED_CHUNK: "Envoi des historiques",
                ZIPPING_CONFIG: "Envoi de la configuration",
                SENDING_CONFIG: "Envoi de la configuration",
                SPLITTING_DATABASE_FILE: "Envoi de la base de données",
                ZIPPING_DATABASE_FILE: "Envoi de la base de données",
                SENDING_DATABASE_FILE: "Envoi de la base de données",
                DATABASE_FILE_SENT: "Envoi de la base de données",
                FINALYSING: "Finalisation du backup",
                DOWNLOADING_FILE: "Téléchargement en cours",
                FILE_MANAGED: "Téléchargement en cours"
              }
            },
            daysOfWeek: {
              0: "Lundi",
              1: "Mardi",
              2: "Mercredi",
              3: "Jeudi",
              4: "Vendredi",
              5: "Samedi",
              6: "Dimanche"
            },
            session: {
              total:{
                singular : "Partie",
                plural : "Parties"
              },
              deleteMessage: {
                singular: "Supprimer définitivement cette partie ?",
                plural: "Supprimer définitivement ces [NB] parties ?"
              },
              actions:{
                bookmark:{
                  true : "Mettre en favoris",
                  false : "Retirer des favoris"
                },
                replay: "Lancer le replay",
                delete : "Supprimer",
                categorize: "Catégoriser"
              },
              columns: {
                problem: {
                  name: "",
                  title: "Problème"
                },
                bookmark: {
                  name: "",
                  title: "Favoris"
                },
                notes: {
                  name: "",
                  title: "Notes"
                },
                view_date: {
                  name: "",
                  title: "Date de consultation"
                },
                name: {
                  name: "Nom de la partie",
                  title: "Nom de la partie"
                },
                day_of_week: {
                  name: "Jour",
                  title: "Jour de la semaine"
                },
                site: {
                  name: "",
                  title: "Room"
                },
                date: {
                  name: "Date de début",
                  title: "Date de début"
                },
                end_date: {
                  title: "Date de fin"
                },
                category: {
                  name: "",
                  title: "Catégorie"
                },
                time_spent: {
                  name: "Durée",
                  title: "Durée"
                },
                nbHands: {
                  name: "Mains",
                  name_singular: "Main",
                  title: "Mains"
                },
                game_format: {
                  name: "",
                  title: "Format"
                },
                game_variant: {
                  name: "",
                  title: "Variante"
                },
                structure_type: {
                  name: "",
                  title: "Structure"
                },
                special_type: {
                  name: "",
                  title: "Spécialité"
                },
                buyin: {
                  name: "Buy-in",
                  title: "Buy-in"
                },
                prizepool: {
                  name: "Prizepool",
                  title: "Prizepool"
                },
                nbplayers: {
                  name: "Entrées",
                  title: "Nombre de participants",
                  unknown: "Entrées inconnues"
                },
                finish: {
                  name: "Place",
                  title: "Place finale"
                },
                amount_global: {
                  name: "",
                  title: "Coût"
                },
                gain: {
                  name: "Gain",
                  title: "Gain"
                },
                netgain: {
                  name: "Net",
                  title: "Net"
                },
                limit: {
                  name: "Limite",
                  title: "Limite"
                },
                rake: {
                  name: "Rake",
                  title: "Rake"
                },
                netgain_vshero: {
                  name: "Vs Hero",
                  title: "Net vs Hero"
                },
                netgain_ev: {
                  name: "Net EV",
                  title: "Net EV"
                },
                last_hand: {
                  name: "Dernière main",
                  title: "Dernière main"
                }
              },
              categorization: {
                title: "Catégorisation des sessions",
                none: "Sans catégorie"
              }
            }
          }
        }
      },
      it: {
        translations: {
          version: "Versione",
          home: "Pagina iniziale",
          close: "Chiudere",
          powered: "Realizzato da Xeester",
          fullscreen: "Schermo intero",
          exitFullscreen: "Uscire dalla modalità a schermo intero",
          options: "Opzioni",
          hand: "Mano",
          buyin: "Buy-in",
          level: "Livello",
          hero: "Hero",
          player: "Giocatore",
          background: "Background",
          table: "Tavolo",
          shortcuts: "Collegamenti",
          not_allowed: "Questo replay è privato",
          not_exists: "Questo replay non esiste",
          gotoXeester: "Andare a Xeester",
          disclaimer: "Usar o Xeester está em conformidade com os Termos e Condições dos sites suportados. Direitos autorais © 2011 - [DATE] Xeester, todos os direitos reservados.",
          noResults: "Nessun risultato",
          hudDisclaimer  : "Mouse sopra un giocatore per vedere il loro HUD",
          error: {
            title: "Oops, è sorto un problema",
            message: "Ci scusiamo per l'inconveniente, riprova più tardi.",
            reload: "Ricarica",
            wrong_id: "Cattivo replay ID"
          },
          actionbar: {
            winamaxNav: "Navigazione Winamax",
            firstHand: "Prima mano",
            tenLessHand: "10 mani anteriori",
            previousHand: "Mano precedente",
            previousAction: "Azione precedente",
            nextAction: "Prossima azione",
            nextHand: "Prossima mano",
            tenMoreHand: "10 mani dopo",
            lastHand: "Ultima mano",
            play: "Gioca",
            replay: "Ripetere",
            stop: "Stop",
            spacebar: "Barra spaziatrice",
            speed: "Velocità",
            timeline: "Cronologia",
            sounds_mute: "Disattivare il suono",
            sounds_unmute: "Riattivare il suono"
          },
          events: {
            NONE: "",
            FOLD: "Fold",
            CHECK: "Check",
            CALL: "Call",
            BET: "Bet",
            RAISE: "Raise",
            UNCALLED_BET: "Recupera la sua puntata",
            POSTS_SB: "Mette small blind",
            POSTS_BB: "Mette big blind",
            POSTS_DEAD_BB: "Mette un blind",
            POSTS_ANTE: "Mette ante",
            COLLECT: "Recupera",
            WON_HAND: "Ha vinto la mano",
            FINISH: "A finito il torneo",
            WIN_BOUNTY: "Vince un bounty",
            REBUY: "Rebuy",
            DOUBLE_REBUY: "Double Rebuy",
            SAID: "Dice",
            SHOW: "Mostra",
            MUCK: "Nasconde",
            REALLYMUCK: "Nasconde",
            AT_SHOWDOWN: "E' allo showdown",
            DECONNECT: "È disconnesso",
            RECONNECT: "Riconnette",
            TANK: "Tank",
            SITOUT: "Sits out",
            SITIN: "Sits down"
          },
          sessionTypes: {
            1: "Torneo",
            2: "Cashgame"
          },
          replayApp: {
            // v2-1379 : le bandeau du jeton Space KO
            spaceKoLevel: "Livello",
            spaceKoAvg: "Media",
            view: "vista",
            views: "viste",
            subscribe: "Iscriviti",
            unsubscribe: "Cancella l'iscrizione",
            subscriber: "abbonato",
            subscribers: "abbonati",
            related: "Ultimi replay",
            played: "Giocato il",
            edit: "Modifica la mano",
            cancel: "Annulla",
            user_replay: "replay",
            user_replays: "replays",
            winner: "Vincitore",
            comment: "Commento",
            comments: "Commenti",
            post_comment: "Commentare",
            comment_placeholder: "Aggiungi un commento pubblico...",
            visibility: {
              private: "Privato",
              public: "Pubblico",
              switch: "Passa a"
            },
            delete: "Cancellare",
            deleteReplay: "Cancellare il replay",
            deleteReplayMessage: "Questa azione è irreversibile.",
            deleteReplayMessage2: "Vuoi cancellare questo replay?",
            deleted: "Replay cancellato",
            deletedError: "Il replay non poteva essere cancellato.",
            share: {
              facebook: "Condividere su Facebook",
              twitter: "Condividere su Twitter",
              embed: "Integrare",
              link: "Copia url",
              copied: "Collegamento copiato negli appunti",
              copyCode: "Copiare il codice",
              codeCopied: "Codice copiato negli appunti"
            },
            user: {
              login: "Login",
              password: "Password",
              email: "email",
              signUp: "Iscriviti",
              disconnect: "Scollegare",
              username: "Login",
              login_username: "Login",
              error: "Identificatori non corretti",
              forgot: "Hai dimenticato la tua password ?",
              alreadyMember: "Sei già membro ?",
              notMemberYet: "Non sei ancora registrato ?",
              discover: "Scopri Xeester",
              showReplays: "Vedere i miei replay",
              remember: "Ricordati di me"
            },
            votes: {
              title: "Voti",
              icon: "VO",
              singular: "voto",
              plural: "Voti",
              0: "Senza preavviso",
              1: "Ben fatto",
              2: "Bel bluff",
              3: "Oh, mio Dio !",
              4: "Bad beat"
            }
          },
          navigation: {
            home: "Home",
            history: "Storia",
            myReplays: "I miei replays",
            settings: "Preferenze",
            rankings: {
              title: "Classifiche",
              viewed: "I più visti",
              last: "Ultimi replays",
              commented: "I più commentati",
              voted: "I più votati",
              private: "Privati",
              public: "Pubblici"
            },
            subscriptions: {
              title: "Abbonamenti"
            }
          },
          chanelApp: {
            lastReplays: "Ultimi replays",
            mostViewed: "I più visti",
            home: "Home",
            replays: "Replays",
            search: "Ricerca",
            filters: {
              all: "Tutti",
              allPrivate: "Rendi tutto privato",
              allPublic: "Rendi tutto pubblico",
              allPrivateConfirm: "Rendere privato {{count}} replay?",
              allPrivateConfirm_plural: "Rendere privati {{count}} replays?",
              allPublicConfirm: "Rendere pubblico {{count}} replay?",
              allPublicConfirm_plural: "Rendere pubblici {{count}} replays?",
              allPublicWarning: "I replays che hai reso privati uno per uno torneranno pubblici.",
              allError: "Impossibile effettuare la modifica.",
              confirm: "Conferma",
              cancel: "Annulla",
              select: "Selezionare"
            },
            selection: {
              count: "Selezionati: {{count}}",
              all: "Seleziona tutto",
              none: "Deseleziona tutto",
              delete: "Elimina",
              cancel: "Annulla",
              deleteTitle: "Eliminare i replay selezionati",
              deleteConfirm: "Eliminare {{count}} replay? I suoi commenti, voti e visualizzazioni spariscono con lui.",
              deleteConfirm_plural: "Eliminare {{count}} replay? I loro commenti, voti e visualizzazioni spariscono con loro.",
              deleted: "{{count}} replay eliminato",
              deleted_plural: "{{count}} replay eliminati",
              deleteError: "Non è stato possibile eliminare i replay.",
              deletePartial: "{{count}} replay eliminato, non è stato possibile eliminare gli altri.",
              deletePartial_plural: "{{count}} replay eliminati, non è stato possibile eliminare gli altri.",
              public: "Rendi pubblici",
              private: "Rendi privati",
              publicTitle: "Rendere pubblici i replay selezionati",
              privateTitle: "Rendere privati i replay selezionati",
              madePublic: "{{count}} replay reso pubblico",
              madePublic_plural: "{{count}} replay resi pubblici",
              madePrivate: "{{count}} replay reso privato",
              madePrivate_plural: "{{count}} replay resi privati",
              visibilityPartial: "{{count}} replay modificato, non è stato possibile modificare gli altri.",
              visibilityPartial_plural: "{{count}} replay modificati, non è stato possibile modificare gli altri."
            },
            edit: "Modifica"
          },
          homeApp: {
            featured: "I più visti"
          },
          ads: {
            sponsored: "Contenuto sponsorizzato"
          },
          landing: {
            h1: "Vantati",
            h2: "Condividi i tuoi replays !",
            description:
              "Pubblicare le tue migliori mani poker non è mai stato così facile come con Opencards. Basta un clic per pubblicare, condividere e poi fa le tue domande alla nostra comunità. <a href='/' target='_blank'>Xeester</a> di più di 60.000 giocatori !<br>Diventa un membro emerito e dai i tuoi consigli e la tua opinione sulle mani migliori (ma anche le peggiori) che vedi.<br><br>È tempo che tu mostri le tue carte !",
            publishLive: "Pubblica in diretta dal tuo HUD",
            publishLiveDescription:
              "Eri in good run, iper concentrato, e ora villain ha appena ridotto la tua pila andando a pescare con 7-2 offsuit...<br>Condividi la tua rabbia, e pubblica in un click dal tuo HUD quest'ultima mano, e raccogli le opinioni della comunità!<br><br>Ma attenzione, tutti possono non condividere il tuo punto di vista ...",
            share: "Condividi le tue mani già giocate",
            shareDescription:
              "Hai appena lasciato il tavolo, il poker è finito per stasera!<br>Ma non si può fare a meno di pensare a quelle poche mani chiave che hanno fatto alzare il battito cardiaco ...<br>Hai preso le decisioni giuste? Hai analizzato bene i tuoi avversari?<br>E poi c'è questa famosa ultima mano, che finalmente ti ha fatto vincere questo torneo che è durato quasi 6 ore ...<br><br>Condividila con gli altri , riapri la mano su Xeester e pubblicala !",
            featuredHand: "AVRAI LA MANO DEL MESE ?",
            openHand: "Vedere la mano"
          },
          settings: {
            infos: "Informazione",
            display: "Display",
            update: "Aggiorna",
            description: "Descrizione del tuo chanel",
            description_placeholder:
              "Scrivi una breve descrizione su di te e sul tuo gioco di poker",
            notifications: "Notifiche via e-mail",
            notify_subscriptions: "Quando un utente si iscrive al mio chanel",
            notify_comments: "Quando viene pubblicato un nuovo commento",
            notify_replays: "Quando viene pubblicato un nuovo video",
            update_error: "Si è verificato un errore",
            description_updated: "Descrizione aggiornata",
            notifications_updated: "Notifiche aggiornate",
            banner: "Immagine banner",
            banner_text:
              "Per ottenere i migliori risultati su tutti i dispositivi, utilizzare un'immagine di almeno 2048 x 335 pixel e 2MB o meno.",
            banner_size_error:
              "Utilizzare un'immagine di almeno 2048 x 335 pixel",
            banner_weight_error:
              "Utilizzare un'immagine che sia di 2 Mo o meno",
            avatar: "Avatar",
            avatar_text:
              "Utilizzare un'immagine quadrata di almeno 128 x 128 pixel e 500 ko o meno.",
            avatar_size_error:
              "Utilizzare un'immagine quadrata di almeno 128 x 128 pixel",
            avatar_weight_error: "Utilizzare un'immagine di 500 ko o meno",
            upload: "Carica",
            change: "Cambia",
            gallery: "Galleria"
          },
          poktools: {
            back: "Indietro",
            pending: "La tua valutazione terminerà tra [NB] giorni",
            unauthorized:
              "La tua licenza non è più valida, passa a TITAN per utilizzare gli strumenti!",
            positions: {
              LJ: "Lo Jack",
              HJ: "Hi Jack",
              CO: "Cut Off",
              BU: "Bottone",
              SB: "Small Blind",
              BB: "Big Blind"
            },
            trainer: {
              title: "TRAINER",
              description:
                "TRAINER è uno strumento che ti permette di allenarti in situazioni preflop. Questo strumento è un modo efficace per correggere facilmente le perdite. Con tre livelli di difficoltà, si adatta al tuo livello di gioco che tu sia un principiante o un giocatore più esperto.",
              start: "Inizia formazione",
              options: "Opzioni",
              right_answer: "L'EV in questo punto è [EV] BB!",
              wrong_answer: "ATTENZIONE: EV in questo punto è [EV] BB!",
              next: "Avanti>",
              speed: {
                0: "Nessun timer",
                2: "2 secondi",
                5: "5 secondi",
                10: "10 secondi"
              },
              level: {
                name: "Difficoltà",
                1: "Facile",
                2: "Media",
                3: "Difficile"
              },
              game: {
                name: "Tipo di gioco"
              },
              situation: {
                name: "Situazione",
                or: "o"
              },
              hero: "eroe",
              vilain: "cattivo"
            },
            fastpok: {
              title: "FASTPOK",
              description:
                "FastPok è sia un risolutore preflop che un software di supporto decisionale. Pertanto, il suo design ibrido gli consente di beneficiare della velocità del software di supporto decisionale e della precisione dei risolutori preflop.",
              start: "Avvia",
              situation: {
                title: "Situazione"
              },
              players: {
                title: "Numero di giocatori",
                short: "giocatori"
              },
              vilain: {
                title: "Posizione / i del / i cattivo / i"
              },
              position: {
                title: "posizione del title"
              },
              stack: {
                title: "Stack effettivo (in BB, min = 2BB)"
              },
              ante: {
                title: "Ante (in% di BB)"
              },
              launch: "Avvia l'analisi",
              analysis: {
                title: "Analizzare",
                tip: "Passa il mouse su una mano per vedere i dettagli",
                nodata: "Seleziona i criteri"
              },
              open_push:
                "Nessuno ha aperto prima di me, posso muovermi in modo redditizio?",
              call_push: "Sto affrontando una spinta, cosa devo fare?"
            },
            rp: {
              title: "Risk Premium",
              description:
                "Risk Premium ti permette di conoscere la correttezza di cui ha bisogno un giocatore quando va all-in contro un altro in una situazione in cui c'è un impatto legato all'ICM. Conoscere il Risk Premium di una situazione all-in permette di evitare di commettere errori ICM , quindi è particolarmente adatto per i tornei di poker. ",
              start: "Avvia",
              stacks: "Stack",
              payouts: "Premi",
              add: "Aggiungi",
              calculate: "Calcola",
              reset: "Reset",
              prorata: "Pro rata",
              chips: "Token",
              warning:
                "Specificare 'uno stack VS uno stack' per accelerare il calcolo"
            },
            error: "Si è verificato un errore"
          }
        }
      },
      pt: {
        translations: {
          version: "Versão",
          home: "Início",
          close: "Fechar",
          powered: "Desenvolvido por Xeester",
          fullscreen: "Full screen",
          exitFullscreen: "Sair de Full screen",
          options: "Opções",
          hand: "Mão",
          buyin: "Buy-in",
          level: "Nível",
          hero: "Herói",
          player: "Jogador",
          background: "Background",
          table: "Mesa",
          shortcuts: "Atalhos",
          not_allowed: "Este replay é privado",
          not_exists: "Id de replay inexistente",
          gotoXeester: "Ir para Xeester",
          noResults: "Sem resultados",
          hudDisclaimer  : "Passe o mouse sobre um jogador para ver o seu HUD",
          error: {
            title: "Ops, algo correu mal",
            message:
              "Pedimos desculpa pelo inconveniente, tente novamente mais tarde",
            reload: "Reload",
            wrong_id: "Id de replay errado"
          },
          actionbar: {
            winamaxNav: "Navegação Winamax",
            firstHand: "Primeira mão",
            tenLessHand: "Dez mãos antes",
            previousHand: "Mão anterior",
            previousAction: "Ação anterior",
            nextAction: "Próxima ação",
            nextHand: "Próxima mão",
            tenMoreHand: "Dez mãos depois",
            lastHand: "Última mão",
            play: "Play",
            replay: "Replay",
            stop: "Stop",
            spacebar: "Tecla espaço",
            speed: "Velocidade",
            timeline: "Cronologia",
            sounds_mute: "Sem som",
            sounds_unmute: "Com som"
          },
          events: {
            NONE: "",
            FOLD: "Folds",
            CHECK: "Checks",
            CALL: "Calls",
            BET: "Bets",
            RAISE: "Raises",
            UNCALLED_BET: "Uncalled bet",
            POSTS_SB: "Coloca a small blind",
            POSTS_BB: "Coloca a big blind",
            POSTS_DEAD_BB: "Coloca a blind",
            POSTS_ANTE: "Coloca ante",
            COLLECT: "Coleta",
            WON_HAND: "Ganhou a mão",
            FINISH: "Terminou o torneio",
            WIN_BOUNTY: "Ganha um bounty",
            REBUY: "Rebuy",
            DOUBLE_REBUY: "Duplo Rebuy",
            SAID: "Says",
            SHOW: "Shows",
            MUCK: "Mucks",
            REALLYMUCK: "Mucks",
            AT_SHOWDOWN: "Está em showdown",
            DECONNECT: "Está desconectado",
            RECONNECT: "Está a reconectar",
            TANK: "Tank",
            SITOUT: "Sits out",
            SITIN: "Sits in"
          },
          sessionTypes: {
            1: "Torneio",
            2: "Cashgame"
          },
          replayApp: {
            // v2-1379 : le bandeau du jeton Space KO
            spaceKoLevel: "Nível",
            spaceKoAvg: "Média",
            view: "visualização",
            views: "visualizações",
            subscribe: "subscrever",
            unsubscribe: "cancelar subscrição",
            subscriber: "subscritor",
            subscribers: "subscritores",
            related: "Últimos replays",
            played: "Jogado",
            edit: "Mão editada",
            cancel: "Cancelar",
            user_replay: "replay",
            user_replays: "replays",
            winner: "Vencedor",
            comment: "comentário",
            comments: "comentários",
            post_comment: "Comentar",
            comment_placeholder: "Adicionar um comentário público...",
            visibility: {
              private: "Privado",
              public: "Público",
              switch: "Alterar para"
            },
            delete: "Eliminar",
            deleteReplay: "Eliminar replay",
            deleteReplayMessage: "Esta ação é irreversível..",
            deleteReplayMessage2: "Quer mesmo eliminar este replay?",
            deleted: "Replay eliminado",
            deletedError: "Não foi possível eliminar o Replay",
            share: {
              facebook: "Partilhar no Facebook",
              twitter: "Partilhar no Twitter",
              embed: "Integrar",
              link: "Copiar url",
              copied: "Link copiado para a área de transferência",
              copyCode: "Copiar código",
              codeCopied: "Código copiado para a área de transferência"
            },
            user: {
              login: "Entrar",
              password: "Palavra-passe",
              email: "email",
              signUp: "Regista-te",
              disconnect: "Desconectar",
              username: "Nome de utilizador",
              login_username: "Login",
              error: "Credenciais incorretas",
              forgot: "Esqueceu a palavra-passe?",
              alreadyMember: "Já é um membro?",
              notMemberYet: "Ainda não tens conta?",
              discover: "Descobrir o Xeester",
              showReplays: "Os meus replays",
              remember: "Guardar contraseña"
            },
            votes: {
              title: "Votos",
              icon: "VO",
              singular: "voto",
              plural: "votos",
              0: "Sem opinião",
              1: "Bem jogado",
              2: "Bom bluff",
              3: "Oh meu deus!",
              4: "Bad beat"
            }
          },
          navigation: {
            home: "Início",
            history: "Histórico",
            myReplays: "Meu canal",
            settings: "Configurações",
            rankings: {
              title: "Rankings",
              viewed: "Mais vistos",
              last: "Últimos replays",
              commented: "Mais comentados",
              voted: "Mais votados",
              private: "Privados",
              public: "Públicos"
            },
            subscriptions: {
              title: "Subscrições"
            }
          },
          chanelApp: {
            lastReplays: "Últimos replays",
            mostViewed: "Mais vistos",
            home: "Início",
            replays: "Replays",
            search: "Pesquisar",
            filters: {
              all: "Todos",
              allPrivate: "Tornar tudo privado",
              allPublic: "Tornar tudo público",
              allPrivateConfirm: "Tornar {{count}} replay privado?",
              allPrivateConfirm_plural: "Tornar {{count}} replays privados?",
              allPublicConfirm: "Tornar {{count}} replay público?",
              allPublicConfirm_plural: "Tornar {{count}} replays públicos?",
              allPublicWarning: "Os replays que tornaste privados um a um voltarão a ser públicos.",
              allError: "Não foi possível fazer a alteração.",
              confirm: "Confirmar",
              cancel: "Cancelar",
              select: "Selecionar"
            },
            selection: {
              count: "Selecionados: {{count}}",
              all: "Selecionar tudo",
              none: "Desmarcar tudo",
              delete: "Eliminar",
              cancel: "Cancelar",
              deleteTitle: "Eliminar os replays selecionados",
              deleteConfirm: "Eliminar {{count}} replay? Os comentários, votos e visualizações vão com ele.",
              deleteConfirm_plural: "Eliminar {{count}} replays? Os comentários, votos e visualizações vão com eles.",
              deleted: "{{count}} replay eliminado",
              deleted_plural: "{{count}} replays eliminados",
              deleteError: "Não foi possível eliminar os replays.",
              deletePartial: "{{count}} replay eliminado, não foi possível eliminar os outros.",
              deletePartial_plural: "{{count}} replays eliminados, não foi possível eliminar os outros.",
              public: "Tornar públicos",
              private: "Tornar privados",
              publicTitle: "Tornar públicos os replays selecionados",
              privateTitle: "Tornar privados os replays selecionados",
              madePublic: "{{count}} replay tornado público",
              madePublic_plural: "{{count}} replays tornados públicos",
              madePrivate: "{{count}} replay tornado privado",
              madePrivate_plural: "{{count}} replays tornados privados",
              visibilityPartial: "{{count}} replay alterado, não foi possível alterar os outros.",
              visibilityPartial_plural: "{{count}} replays alterados, não foi possível alterar os outros."
            },
            edit: "Personalizar o meu canal"
          },
          homeApp: {
            featured: "Mais vistos"
          },
          ads: {
            sponsored: "Conteúdo patrocinado"
          },
          landing: {
            h1: "Vamos all in",
            h2: "Partilha os teus replays!",
            description:
              "Publicar as tuas melhores mãos de póquer nunca foi tão fácil como com o Opencards. Num só clique, publica, partilha e depois coloca as tuas perguntas à comunidade do <a href='/' target='_blank'>Xeester</a> que conta com mais de 60,000 jogadores!<br>Torna-te um membro emérito e dá os teus conselhos e opiniões sobre as melhores (mas também sobre as piores) mãos que vês ... <br> <br> É hora de abrir as cartas! ",
            publishLive: "Publica diretamente do teu HUD",
            publishLiveDescription:
              "Estavas no meio de uma boa run, híper concentrado, e agora o vilão acabou de reduzir a tua stack para metade indo à pesca com 7-2 offsuit na mão ... <br> Partilha a tua raiva e publica através de um clique no teu HUD esta última mão, e recebe as opiniões da comunidade! <br> <br> Mas cuidado, nem todos podem partilhar o teu ponto de vista ... ",
            share: "Partilha as tuas mãos já jogadas",
            shareDescription:
              "Acabaste de sair da mesa, o póquer acabou por esta noite! <br> Mas não podes deixar de pensar naquelas mãos importantes que fizeram o teu coração disparar ... <br> Tomaste as decisões certas? analisaste bem os adversários? <br> E depois há esta famosa última mão, que finalmente te fez ganhar o torneio que durou quase 6 horas ... <br> <br> Partilha com os outros, reabre a tua mão no Xeester e publica isso!",
            featuredHand: "Serás tu o jogador com a mão do mês?",
            openHand: "Vê aquela mão"
          },
          settings: {
            infos: "Informações",
            display: "Exibição",
            update: "Update",
            description: "Descrição do teu canal",
            description_placeholder:
              "Escreve uma breve descrição sobre o teu jogo de póquer",
            notifications: "Notificações de email",
            notify_subscriptions:
              "Quando um utilizador se inscreve no meu canal",
            notify_comments: "Quando um novo comentário é publicado",
            notify_replays: "Quando um novo vídeo é publicado",
            update_error: "Ocorreu um erro",
            description_updated: "Descrição atualizada",
            notifications_updated: "Notificações atualizadas",
            banner: "Imagem do Banner",
            banner_text:
              "Para obter os melhores resultados em todos os dispositivos, usa uma imagem com pelo menos 2048 x 335 pixels e com um máximo de 2 MB.",
            banner_size_error:
              "Usa uma imagem com pelo menos 2048 x 335 pixéis",
            banner_weight_error: "Usa uma imagem com um máximo de 2 MB",
            avatar: "Avatar",
            avatar_text:
              "Usa uma imagem quadrada com pelo menos 128 x 128 pixels e com o máximo de 500 KB.",
            avatar_size_error:
              "Usa uma imagem quadrada com pelo menos 128 x 128 pixels",
            avatar_weight_error: "Usa uma imagem com máximo de 500 KB",
            upload: "Upload",
            change: "Alterar",
            gallery: "Galeria"
          },
          poktools: {
            back: "Voltar",
            pending: "Sua avaliação terminará em [NB] dias",
            unauthorized:
              "Sua licença não é mais válida, atualize para o TITAN para usar as ferramentas!",
            positions: {
              LJ: "Lo Jack",
              HJ: "Hi Jack",
              CO: "Cut Off",
              BU: "Botão",
              SB: "Small Blind",
              BB: "Big Blind"
            },
            trainer: {
              title: "TRAINER",
              description:
                "TRAINER é uma ferramenta que permite treinar em situações pré-flop. Esta ferramenta é uma forma eficaz de corrigir vazamentos com facilidade. Com três níveis de dificuldade, adapta-se ao seu nível de jogo, seja você um iniciante ou um jogador mais experiente.",
              start: "Começar a treinar",
              options: "Opções",
              right_answer: "O EV neste local é [EV] BB!",
              wrong_answer: "ATENÇÃO: EV neste local é [EV] BB!",
              next: "Próximo>",
              speed: {
                0: "Sem cronômetro",
                2: "2 segundos",
                5: "5 segundos",
                10: "10 segundos"
              },
              level: {
                name: "Dificuldade",
                1: "Fácil",
                2: "Média",
                3: "Difícil"
              },
              game: {
                name: "Tipo de jogo"
              },
              situation: {
                name: "Situação",
                or: "ou"
              },
              hero: "herói",
              vilain: "vilão"
            },
            fastpok: {
              title: "FASTPOK",
              description:
                "FastPok é um solucionador pré-flop e um software auxiliar de decisão. Portanto, seu design híbrido permite que ele se beneficie da velocidade do software auxiliar de decisão e da precisão dos solucionadores pré-flop.",
              start: "Iniciar",
              situation: {
                title: "Situação"
              },
              players: {
                title: "Número de jogadores",
                short: "jogadores"
              },
              vilain: {
                title: "Posição (ões) do (s) vilão (s)"
              },
              position: {
                title: "Posição"
              },
              stack: {
                title: "Pilha efetiva (em BB, min = 2BB)"
              },
              ante: {
                title: "Ante (em% de BB)"
              },
              launch: "Iniciar a análise",
              analysis: {
                title: "Analisar",
                tip: "Passe o mouse sobre uma mão para ver o detalhe",
                nodata: "Selecione os critérios"
              },
              open_push:
                "Ninguém abriu antes de mim, posso fazer all-in lucrativamente?",
              call_push: "Estou enfrentando um push, o que devo fazer?"
            },
            rp: {
              title: "Risk Premium",
              description:
                "O Risk Premium permite que você saiba a justiça que um jogador precisa quando vai all-in contra outro em uma situação onde há um impacto relacionado ao ICM. Conhecer o Risk Premium de uma situação all-in permite evitar cometer erros de ICM , por isso é particularmente adequado para torneios de poker. ",
              start: "Iniciar",
              stacks: "Pilhas",
              payouts: "Recompensas",
              add: "Adicionar",
              calculate: "Calcular",
              reset: "Redefinir",
              prorata: "Pro rata",
              chips: "Tokens",
              warning:
                "Especifique 'uma pilha VS uma pilha' para acelerar o cálculo"
            },
            error: "Ocorreu um erro"
          }
        }
      },
      es: {
        translations: {
          version: "Versión",
          home: "Inicio",
          close: "Cerrar",
          powered: "Impulsado por Xeester",
          fullscreen: "Pantalla completa",
          exitFullscreen: "Salir de pantalla completa",
          options: "Opciones",
          hand: "Mano",
          buyin: "Buy-in",
          level: "Nivel",
          hero: "Héroe",
          player: "Jugador",
          background: "Fondo",
          table: "Mesa",
          shortcuts: "Atajos",
          not_allowed: "Esta repetición es privada",
          not_exists: "ID de repetición incorrecta",
          gotoXeester: "Ir a Xeester",
          disclaimer: "El uso de Xeester cumple con los Términos y Condiciones de los sitios web compatibles. Copyright © 2011 - [DATE] Xeester, todos los derechos reservados.",
          noResults: "Sin resultados",
          hudDisclaimer: "Pasa el ratón sobre un jugador para ver su HUD",
          error: {
            title: "Ups, algo salió mal",
            message: "Lamentamos las molestias, inténtelo de nuevo más tarde",
            reload: "Recargar",
            wrong_id: "ID de repetición incorrecta"
          },
          actionbar: {
            winamaxNav: "Navegación Winamax",
            firstHand: "Primera mano",
            tenLessHand: "Diez manos antes",
            previousHand: "Mano anterior",
            previousAction: "Acción anterior",
            nextAction: "Acción siguiente",
            nextHand: "Mano siguiente",
            tenMoreHand: "Diez manos después",
            lastHand: "Última mano",
            play: "Reproducir",
            replay: "Repetir",
            stop: "Detener",
            spacebar: "Barra espaciadora",
            speed: "Velocidad",
            timeline: "Cronología",
            sounds_mute: "Silenciar",
            sounds_unmute: "Activar sonido"
          },
          events: {
            NONE: "",
            FOLD: "Se tira",
            CHECK: "Pasar",
            CALL: "Igualar",
            BET: "Apostar",
            RAISE: "Subir",
            UNCALLED_BET: "Apuesta no igualada",
            POSTS_SB: "Pone ciega pequeña",
            POSTS_BB: "Pone ciega grande",
            POSTS_DEAD_BB: "Pone una ciega",
            POSTS_ANTE: "Pone ante",
            COLLECT: "Cobra",
            WON_HAND: "Ganó la mano",
            FINISH: "Terminó el torneo",
            WIN_BOUNTY: "Gana una recompensa",
            REBUY: "Recompra",
            DOUBLE_REBUY: "Doble recompra",
            SAID: "Dice",
            SHOW: "Muestra",
            MUCK: "Descarta",
            REALLYMUCK: "Descarta",
            AT_SHOWDOWN: "Está en el showdown",
            DECONNECT: "Se desconectó",
            RECONNECT: "Se reconecta",
            TANK: "Piensa",
            SITOUT: "Se ausenta",
            SITIN: "Se sienta"
          },
          sessionTypes: {
            1: "Torneo",
            2: "Cash game"
          },
          replayApp: {
            // v2-1379 : le bandeau du jeton Space KO
            spaceKoLevel: "Nivel",
            spaceKoAvg: "Prom",
            view: "vista",
            views: "vistas",
            subscribe: "suscribirse",
            unsubscribe: "cancelar suscripción",
            subscriber: "suscriptor",
            subscribers: "suscriptores",
            related: "Últimas repeticiones",
            played: "Jugado",
            edit: "Editar mano",
            cancel: "Cancelar",
            user_replay: "repetición",
            user_replays: "repeticiones",
            winner: "Ganador",
            comment: "comentario",
            comments: "comentarios",
            post_comment: "Comentar",
            comment_placeholder: "Agrega un comentario público...",
            visibility: {
                private: "Privado",
                public: "Público",
                switch: "Cambiar a"
            },
            delete: "Eliminar",
            deleteReplay: "Eliminar repetición",
            deleteReplayMessage: "Esta acción es irreversible.",
            deleteReplayMessage2: "¿Quieres eliminar esta repetición?",
            deleted: "Repetición eliminada",
            deletedError: "No se pudo eliminar la repetición",
            share: {
              facebook: "Compartir en Facebook",
              twitter: "Compartir en Twitter",
              embed: "Integrar",
              link: "Copiar URL",
              copied: "Enlace copiado al portapapeles",
              copyCode: "Copiar código",
              codeCopied: "Código copiado al portapapeles"
            },
            user: {
              login: "Iniciar sesión",
              password: "Contraseña",
              email: "correo electrónico",
              signUp: "Registrarse",
              disconnect: "Desconectar",
              username: "Nombre de usuario",
              login_username: "Iniciar sesión",
              error: "Credenciales incorrectas",
              forgot: "¿Olvidaste tu contraseña?",
              alreadyMember: "¿Ya eres miembro?",
              notMemberYet: "¿Aún no tienes cuenta?",
              discover: "Descubre Xeester",
              showReplays: "Mis repeticiones",
              remember: "Recuérdame"
            },
            votes: {
              title: "Votos",
              icon: "VO",
              singular: "voto",
              plural: "votos",
              0: "Sin opinión",
              1: "Gran jugada",
              2: "Buen farol",
              3: "¡Dios mío!",
              4: "Bad beat"
            }
          },
          navigation: {
            home: "Inicio",
            history: "Historial",
            myReplays: "Mi canal",
            settings: "Configuración",
            rankings: {
              title: "Clasificaciones",
              viewed: "Más vistas",
              last: "Últimas repeticiones",
              commented: "Más comentadas",
              voted: "Más votadas",
              private: "Privados"
            },
            subscriptions: {
              title: "Suscripciones"
            }
          },
          chanelApp: {
            lastReplays: "Últimas repeticiones",
            mostViewed: "Más vistas",
            home: "Inicio",
            replays: "Repeticiones",
            search: "Buscar",
            filters: {
              all: "Todas",
              allPrivate: "Pasar todo a privado",
              allPublic: "Pasar todo a público",
              allPrivateConfirm: "¿Pasar {{count}} repetición a privado?",
              allPrivateConfirm_plural: "¿Pasar {{count}} repeticiones a privado?",
              allPublicConfirm: "¿Pasar {{count}} repetición a público?",
              allPublicConfirm_plural: "¿Pasar {{count}} repeticiones a público?",
              allPublicWarning: "Las repeticiones que pasaste a privado una por una volverán a ser públicas.",
              allError: "No se pudo realizar el cambio.",
              confirm: "Confirmar",
              cancel: "Cancelar",
              select: "Seleccionar"
            },
            selection: {
              count: "Seleccionadas: {{count}}",
              all: "Seleccionar todo",
              none: "Deseleccionar todo",
              delete: "Eliminar",
              cancel: "Cancelar",
              deleteTitle: "Eliminar las repeticiones seleccionadas",
              deleteConfirm: "¿Eliminar {{count}} repetición? Sus comentarios, votos y vistas se van con ella.",
              deleteConfirm_plural: "¿Eliminar {{count}} repeticiones? Sus comentarios, votos y vistas se van con ellas.",
              deleted: "{{count}} repetición eliminada",
              deleted_plural: "{{count}} repeticiones eliminadas",
              deleteError: "No se pudieron eliminar las repeticiones.",
              deletePartial: "{{count}} repetición eliminada, las demás no se pudieron eliminar.",
              deletePartial_plural: "{{count}} repeticiones eliminadas, las demás no se pudieron eliminar.",
              public: "Pasar a público",
              private: "Pasar a privado",
              publicTitle: "Pasar las repeticiones seleccionadas a público",
              privateTitle: "Pasar las repeticiones seleccionadas a privado",
              madePublic: "{{count}} repetición pasada a público",
              madePublic_plural: "{{count}} repeticiones pasadas a público",
              madePrivate: "{{count}} repetición pasada a privado",
              madePrivate_plural: "{{count}} repeticiones pasadas a privado",
              visibilityPartial: "{{count}} repetición cambiada, las demás no se pudieron cambiar.",
              visibilityPartial_plural: "{{count}} repeticiones cambiadas, las demás no se pudieron cambiar."
            },
            edit: "Personalizar mi canal"
          },
          homeApp: {
            featured: "Más vistas"
          },
          ads: {
            sponsored: "Contenido patrocinado"
          },
          landing: {
            h1: "Ve all-in",
            h2: "¡Comparte tus repeticiones!",
            description:
              "Publicar tus mejores manos de póker nunca fue tan fácil como con Opencards. En un clic, publica, comparte y haz tus preguntas a la comunidad de <a href='/' target='_blank'>Xeester</a> de más de 60.000 jugadores.<br>¡Conviértete en un miembro emérito y da tu consejo y opinión sobre las mejores (y también las peores) manos que veas...<br><br>¡Es hora del showdown!",
            publishLive: "Publicar en directo desde tu HUD",
            publishLiveDescription:
              "Estabas en una buena racha, súper concentrado, y de repente el villano te redujo la pila a la mitad yendo a pescar con 7-2 off... <br> Comparte tu frustración y publica en un clic desde tu HUD esta última mano, y recoge las opiniones de la comunidad.<br><br> Pero cuidado, no todos compartirán tu punto de vista...",
            share: "Comparte tus manos pasadas",
            shareDescription:
              "Acabas de dejar la mesa, ¡el póker terminó por esta noche!<br> Pero no puedes evitar pensar en esas manos clave que hicieron subir tus pulsaciones...<br>¿Tomaste las decisiones correctas? ¿Analizaste bien a tus rivales?<br>Y luego está esa última mano famosa, la que finalmente te hizo ganar ese torneo que duró casi 6 horas...<br><br>¡Compártela, reabre tu mano en Xeester y publícala!",
            featuredHand: "¿Tendrás la mano del mes?",
            openHand: "Ver esa mano"
          },
          settings: {
            infos: "Información",
            display: "Visualización",
            update: "Actualizar",
            description: "Descripción de tu canal",
            description_placeholder:
              "Escribe una breve descripción sobre ti y tu juego de póker",
            notifications: "Notificaciones por correo",
            notify_subscriptions: "Cuando un usuario se suscriba a mi canal",
            notify_comments: "Cuando se publique un nuevo comentario",
            notify_replays: "Cuando se publique un nuevo vídeo",
            update_error: "Ocurrió un error",
            description_updated: "Descripción actualizada",
            notifications_updated: "Notificaciones actualizadas",
            banner: "Imagen de portada",
            banner_text:
              "Para los mejores resultados en todos los dispositivos, usa una imagen de al menos 2048 x 335 píxeles y de 2 MB o menos.",
            banner_size_error: "Usa una imagen de al menos 2048 x 335 píxeles",
            banner_weight_error: "Usa una imagen de 2 MB o menos",
            avatar: "Avatar",
            avatar_text:
              "Usa una imagen cuadrada de al menos 128 x 128 píxeles y de 500 KB o menos.",
            avatar_size_error:
              "Usa una imagen cuadrada de al menos 128 x 128 píxeles",
            avatar_weight_error: "Usa una imagen de 500 KB o menos",
            upload: "Subir",
            change: "Cambiar",
            gallery: "Galería"
          },
          poktools: {
            back: "Volver",
            pending: "Tu evaluación terminará en [NB] días",
            unauthorized:
              "Tu licencia ya no es válida, ¡actualiza a TITAN para usar las herramientas!",
            positions: {
              LJ: "Lo Jack",
              HJ: "Hi Jack",
              CO: "Cut Off",
              BU: "Botón",
              SB: "Ciega pequeña",
              BB: "Ciega grande"
            },
            trainer: {
              title: "ENTRENADOR",
              description:
                "ENTRENADOR es una herramienta que te permite entrenar en situaciones de preflop. Es una forma eficaz de corregir fugas fácilmente. Con tres niveles de dificultad, se adapta a tu nivel de juego, seas principiante o más experimentado.",
              start: "Comenzar entrenamiento",
              options: "Opciones",
              right_answer: "El EV en esta situación es [EV] BB!",
              wrong_answer: "ATENCIÓN: El EV en esta situación es [EV] BB!",
              next: "Siguiente >",
              speed: {
                0: "Sin temporizador",
                2: "2 segundos",
                5: "5 segundos",
                10: "10 segundos"
              },
              level: {
                name: "Dificultad",
                1: "Fácil",
                2: "Medio",
                3: "Difícil"
              },
              game: {
                name: "Tipo de juego"
              },
              situation: {
                name: "Situación",
                or: "o"
              },
              hero: "héroe",
              vilain: "villano"
            },
            fastpok: {
              title: "FASTPOK",
              description:
                "FastPok es a la vez un solucionador de preflop y un asistente de decisiones. Su diseño híbrido le permite beneficiarse de la velocidad de un asistente y de la precisión de los solucionadores de preflop.",
              start: "Comenzar",
              situation: {
                title: "Situación"
              },
              players: {
                title: "Número de jugadores",
                short: "jugadores"
              },
              vilain: {
                title: "Posición(es) del/de los villano(s)"
              },
              position: {
                title: "Posición"
              },
              stack: {
                title: "Pila efectiva (en BB, mín = 2BB)"
              },
              ante: {
                title: "Ante (en % de BB)"
              },
              launch: "Iniciar análisis",
              analysis: {
                title: "Análisis",
                tip: "Pasa el ratón sobre una mano para ver el detalle",
                nodata: "Selecciona criterios"
              },
              open_push:
                "Nadie abrió antes que yo, ¿puedo ir all-in con beneficio?",
              call_push: "Estoy frente a un push, ¿qué debo hacer?"
            },
            rp: {
              title: "Risk Premium",
              description:
                "Risk Premium te permite saber la equity que un jugador necesita cuando va all-in contra otro en una situación con impacto de ICM. Conocer el Risk Premium de un all-in permite evitar errores de ICM, por lo que es especialmente útil en torneos de póker.",
              start: "Comenzar",
              stacks: "Pilas",
              payouts: "Premios",
              add: "Añadir",
              calculate: "Calcular",
              reset: "Reiniciar",
              prorata: "Prorrata",
              chips: "Fichas",
              warning: "Especifica 'una pila VS una pila' para acelerar el cálculo"
            },
            error: "Ocurrió un error"
          }
        }
      }

    },
    fallbackLng: "en",
    load: "languageOnly",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    //keySeparator: true, // we use content as keys

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
